<template>
    <nav class="navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row">
        <div class="text-center navbar-brand-wrapper d-flex align-items-center justify-content-start">
            <a class="navbar-brand brand-logo me-5" href="index.html"><img :src="this.base_url + '/assets/img/govt_logo.jpeg'" class="me-2" alt="logo" style="width: 50px;height: 50px;"/></a>
        </div>
        <div class="navbar-menu-wrapper d-flex align-items-center justify-content-end">
            <button class="navbar-toggler navbar-toggler align-self-center" type="button" data-toggle="minimize">
            <span class="icon-menu"></span>
            </button>
            <ul class="navbar-nav mr-lg-2">
            <li class="nav-item nav-search d-none d-lg-block">
                <div class="input-group">
                <div class="input-group-prepend hover-cursor" id="navbar-search-icon">
                    <span class="input-group-text" id="search">
                    <i class="icon-search"></i>
                    </span>
                </div>
                <input type="text" class="form-control" id="navbar-search-input" placeholder="Search now" aria-label="search" aria-describedby="search">
                </div>
            </li>
            </ul>
            <ul class="navbar-nav navbar-nav-right">
            <li class="nav-item dropdown">
                <a class="nav-link count-indicator dropdown-toggle" id="notificationDropdown" href="#" data-bs-toggle="dropdown">
                <i class="icon-bell mx-0"></i>
                <span class="count"></span>
                </a>
                <div class="dropdown-menu dropdown-menu-right navbar-dropdown preview-list" aria-labelledby="notificationDropdown">
                <p class="mb-0 font-weight-normal float-left dropdown-header">Notifications</p>
                <a class="dropdown-item preview-item">
                    <div class="preview-thumbnail">
                    <div class="preview-icon bg-success">
                        <i class="ti-info-alt mx-0"></i>
                    </div>
                    </div>
                    <div class="preview-item-content">
                    <h6 class="preview-subject font-weight-normal">Application Error</h6>
                    <p class="font-weight-light small-text mb-0 text-muted"> Just now </p>
                    </div>
                </a>
                <a class="dropdown-item preview-item">
                    <div class="preview-thumbnail">
                    <div class="preview-icon bg-warning">
                        <i class="ti-settings mx-0"></i>
                    </div>
                    </div>
                    <div class="preview-item-content">
                    <h6 class="preview-subject font-weight-normal">Settings</h6>
                    <p class="font-weight-light small-text mb-0 text-muted"> Private message </p>
                    </div>
                </a>
                <a class="dropdown-item preview-item">
                    <div class="preview-thumbnail">
                    <div class="preview-icon bg-info">
                        <i class="ti-user mx-0"></i>
                    </div>
                    </div>
                    <div class="preview-item-content">
                    <h6 class="preview-subject font-weight-normal">New user registration</h6>
                    <p class="font-weight-light small-text mb-0 text-muted"> 2 days ago </p>
                    </div>
                </a>
                </div>
            </li>
            <!-- <li class="nav-item nav-profile dropdown">
                <a class="nav-link dropdown-toggle" href="#" data-bs-toggle="dropdown" id="profileDropdown">
                <img src="assets/images/faces/face28.jpg" alt="profile" />
                </a>
                <div class="dropdown-menu dropdown-menu-right navbar-dropdown" aria-labelledby="profileDropdown">
                <a class="dropdown-item">
                    <i class="ti-settings text-primary"></i> Settings </a>
                <a class="dropdown-item"  @click="logout">
                    <i class="ti-power-off text-primary"></i> Logout </a>
                </div>
            </li> -->
            <li class="nav-item nav-profile dropdown">
                <a class="nav-link dropdown-toggle" href="#" data-bs-toggle="dropdown" id="profileDropdown">
                    <i class="icon-ellipsis"></i>
                </a>
                <div class="dropdown-menu dropdown-menu-right navbar-dropdown" aria-labelledby="profileDropdown">
                <a class="dropdown-item">
                    <i class="ti-settings text-primary"></i> Settings </a>
                <a class="dropdown-item"  @click="logout">
                    <i class="ti-power-off text-primary"></i> Logout </a>
                </div>
            </li>
            </ul>
            <button class="navbar-toggler navbar-toggler-right d-lg-none align-self-center" type="button" data-toggle="offcanvas">
            <span class="icon-menu"></span>
            </button>
        </div>
    </nav>
</template>
<script>

import Api      from '../util/Api.js';
import Chokidar from '../util/Chokidar.js'; 

export default {
   data(){
    return{
        name               :'',
        base_url           :'',
    }
   },
   // check guard to check admin is logged in or not
   methods:{
    checkGuard()
    {
        this.name     = localStorage.getItem('name');
        this.base_url = window.location.origin;
        let guard     = Chokidar(); 
        
        if(guard != 'user'){
            this.$router.push('/login');
        }
    },
        // admin logout
    logout()
    {
        Api().post('/logout')
                .catch((error) => {
            if (error.response.status == 401) 
            {
                localStorage.removeItem('token');
                localStorage.removeItem('guard');
                this.$swal({
                icon: 'error',
                title: 'Session Expired please login!',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 4000
                });
                this.$router.push('/login');
            } 
        }).then((response)=>{
            if(response.data['success'] == true)
            {
                localStorage.removeItem("token");
                localStorage.removeItem("guard");
                this.$router.push('/login');
                setTimeout(function(){location.reload()}, 10);
            }
        });
    },

   },

   created()
   {
    this.checkGuard();
   }

}
</script>